import axios from 'axios'
import router from '@/router/index'
import { message } from 'ant-design-vue'
import { getToken } from '@/utils/token'
import qs from 'qs'
import store from '@/store'

function filterParams(prefix, value) {
  if (typeof value === 'object') {
    const result = {}
    Object.keys(value).forEach(key => {
      // if (value[key]) {
      result[key] = value[key]
      // }
    })
    return result
  } else {
    return value
  }
}

// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  withCredentials: true, // send cookies when cross-domain requests
  timeout: 0, // request timeout
  paramsSerializer: function (params) {
    return qs.stringify(
      params,
      {
        arrayFormat: 'brackets',
        skipNulls: true,
        filter: filterParams
      })
  }
})

function filterData(data) {
  const result = {}
  try {
    if (typeof data === 'string') {
      const obj = JSON.parse(data)
      Object.keys(obj).forEach(key => {
        // if (obj[key]) {
        result[key] = obj[key]
        // }
      })
      return result
    }

    if (Object.prototype.toString.call(data) === '[object Object]') {
      Object.keys(data).forEach(key => {
        // if (data[key]) {
        result[key] = data[key]
        // }
      })
      return result
    }

    return data
  } catch (e) {
    console.log(e)
    return data
  }
}

// request拦截器
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent

    // post和put请求过滤掉值为空字符、null和undefined的入参
    if (config.method === 'post' || config.method === 'put') {
      config.data = filterData(config.data)
    }

    if (getToken()) {
      config.headers['access-token'] = getToken() // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    }
    // 遍历所有请求头，对非ISO-8859-1字符编码
    if (config.headers) {
      Object.keys(config.headers).forEach(key => {
        const value = config.headers[key]
        // 只编码非空的字符串类型值
        if (typeof value === 'string' && value && /[^\x00-\xFF]/.test(value)) {
          config.headers[key] = encodeURIComponent(value)
        }
      })
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)

// respone拦截器
let lastErrorTime = 0
const showError = (errorMsg) => {
  const now = Date.now()
  if (now - lastErrorTime > 3000) {
    // 控制错误提示的间隔时间为 3 秒
    message.error(errorMsg)
    lastErrorTime = now
  }
}

service.interceptors.response.use(
  async (response) => {
    let { data } = response
    const { status } = response
    if (
      response.config.responseType === 'blob' &&
      data instanceof Blob &&
      !data.type?.includes('application/json')
    ) {
      return data
    }
    if (status === 200) {
      if (data.success || data?.type?.startsWith('application/octet-stream')) {
        return response.data
      }
      if (data instanceof Blob && data.type?.includes('application/json')) {
        data = await new Promise((resolve) => {
          const reader = new FileReader()
          reader.readAsText(data)
          reader.onload = function () {
            resolve(JSON.parse(reader.result))
          }
        })
      }
      // 下载处理
      if (data.code === 2) {
        showError(data?.data[0]?.errorMsg)
      }
      const { error } = data
      if (error) {
        switch (error.code) {
          case '401':
            showError(error.message)
            router.push({ path: '/' }) // 在外部浏览器中打开，跳转到登录页
            break
          case '500':
            showError(error.message)
            break
          default:
            showError(data.error.message)
            break
        }
      } else {
        showError(data.message)
      }
      return response.data
    } else if (status === 401) {
      router.push({ path: '/' }) // 在外部浏览器中打开，跳转到登录页
    }
  },
  (error) => {
    store.commit('system/clearLoading')
    if (!error.response) {
      showError(error.message || error)
      return Promise.reject(new Error(error))
    }

    const { status, data } = error.response
    if (status === 401 || data.status === 401) {
      showError('你将被强制登出，请重新登录')
      store.dispatch('user/logout')
    } else if (status === 500 || status === 502) {
      showError(`后端服务异常(${status})，请联系管理员！`)
      return Promise.reject(error)
    } else {
      showError(data.message || '网络错误')
    }

    return Promise.reject(error)
  }
)

export default service
